import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _548ef99c = () => interopDefault(import('../../../pages/auth-password-reset.vue' /* webpackChunkName: "pages/auth-password-reset" */))
const _dd203174 = () => interopDefault(import('../../../pages/auth-sign-in.vue' /* webpackChunkName: "pages/auth-sign-in" */))
const _b3f38488 = () => interopDefault(import('../../../pages/auth-sign-up.vue' /* webpackChunkName: "pages/auth-sign-up" */))
const _79793f78 = () => interopDefault(import('../../../pages/auth-verify.vue' /* webpackChunkName: "pages/auth-verify" */))
const _d2454816 = () => interopDefault(import('../../../pages/benefits/index.vue' /* webpackChunkName: "pages/benefits/index" */))
const _42f39c56 = () => interopDefault(import('../../../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _6e30ffac = () => interopDefault(import('../../../pages/configurator-equipment.vue' /* webpackChunkName: "pages/configurator-equipment" */))
const _26636beb = () => interopDefault(import('../../../pages/configurator.vue' /* webpackChunkName: "pages/configurator" */))
const _e6f2c7a8 = () => interopDefault(import('../../../pages/consulting.vue' /* webpackChunkName: "pages/consulting" */))
const _3d6810e8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0824f2d1 = () => interopDefault(import('../../../pages/disclaimer.vue' /* webpackChunkName: "pages/disclaimer" */))
const _7b09387e = () => interopDefault(import('../../../pages/facts.vue' /* webpackChunkName: "pages/facts" */))
const _a592ca1e = () => interopDefault(import('../../../pages/video-imprint.vue' /* webpackChunkName: "pages/video-imprint" */))
const _3a8d6142 = () => interopDefault(import('../../../pages/video-privacy-policy.vue' /* webpackChunkName: "pages/video-privacy-policy" */))
const _2e6f2386 = () => interopDefault(import('../../../pages/video-terms-conditions.vue' /* webpackChunkName: "pages/video-terms-conditions" */))
const _e69e5d10 = () => interopDefault(import('../../../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _464381d3 = () => interopDefault(import('../../../pages/video/account.vue' /* webpackChunkName: "pages/video/account" */))
const _4d8fdafa = () => interopDefault(import('../../../pages/video/activities/index.vue' /* webpackChunkName: "pages/video/activities/index" */))
const _bc8725ca = () => interopDefault(import('../../../pages/video/detail.vue' /* webpackChunkName: "pages/video/detail" */))
const _f7f55974 = () => interopDefault(import('../../../pages/video/find/index.vue' /* webpackChunkName: "pages/video/find/index" */))
const _3dda0d87 = () => interopDefault(import('../../../pages/video/stars.vue' /* webpackChunkName: "pages/video/stars" */))
const _72c03e00 = () => interopDefault(import('../../../pages/video/find/selection.vue' /* webpackChunkName: "pages/video/find/selection" */))
const _0515b13a = () => interopDefault(import('../../../pages/video/find/collections/goals.vue' /* webpackChunkName: "pages/video/find/collections/goals" */))
const _b96bcc36 = () => interopDefault(import('../../../pages/video/find/collections/levels.vue' /* webpackChunkName: "pages/video/find/collections/levels" */))
const _69e11662 = () => interopDefault(import('../../../pages/video/find/plans/goals.vue' /* webpackChunkName: "pages/video/find/plans/goals" */))
const _c6ee6e20 = () => interopDefault(import('../../../pages/video/find/plans/levels.vue' /* webpackChunkName: "pages/video/find/plans/levels" */))
const _bb215f1e = () => interopDefault(import('../../../pages/video/find/videos/body-focus-areas.vue' /* webpackChunkName: "pages/video/find/videos/body-focus-areas" */))
const _4cd403a4 = () => interopDefault(import('../../../pages/video/find/videos/durations.vue' /* webpackChunkName: "pages/video/find/videos/durations" */))
const _47a78616 = () => interopDefault(import('../../../pages/video/find/videos/intensities.vue' /* webpackChunkName: "pages/video/find/videos/intensities" */))
const _42744162 = () => interopDefault(import('../../../pages/video/find/videos/single-filter.vue' /* webpackChunkName: "pages/video/find/videos/single-filter" */))
const _5b3c868a = () => interopDefault(import('../../../pages/video/find/videos/sports.vue' /* webpackChunkName: "pages/video/find/videos/sports" */))
const _3d250129 = () => interopDefault(import('../../../pages/video/find/videos/trainers.vue' /* webpackChunkName: "pages/video/find/videos/trainers" */))
const _568d60a2 = () => interopDefault(import('../../../pages/video/playlist/collection/detail.vue' /* webpackChunkName: "pages/video/playlist/collection/detail" */))
const _81cfebf8 = () => interopDefault(import('../../../pages/video/playlist/plan/detail.vue' /* webpackChunkName: "pages/video/playlist/plan/detail" */))
const _7bef7c64 = () => interopDefault(import('../../../pages/history.vue' /* webpackChunkName: "pages/history" */))
const _5703d6c3 = () => interopDefault(import('../../../pages/imprint.vue' /* webpackChunkName: "pages/imprint" */))
const _f2900a66 = () => interopDefault(import('../../../pages/magazine/index.vue' /* webpackChunkName: "pages/magazine/index" */))
const _0fce730a = () => interopDefault(import('../../../pages/order-confirmation.vue' /* webpackChunkName: "pages/order-confirmation" */))
const _004dadae = () => interopDefault(import('../../../pages/platform.vue' /* webpackChunkName: "pages/platform" */))
const _245a834d = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _5581d6fd = () => interopDefault(import('../../../pages/returns.vue' /* webpackChunkName: "pages/returns" */))
const _817bf098 = () => interopDefault(import('../../../pages/right-of-withdrawal.vue' /* webpackChunkName: "pages/right-of-withdrawal" */))
const _31c354fa = () => interopDefault(import('../../../pages/safety-instructions.vue' /* webpackChunkName: "pages/safety-instructions" */))
const _4258ee38 = () => interopDefault(import('../../../pages/shipping.vue' /* webpackChunkName: "pages/shipping" */))
const _5ebd16af = () => interopDefault(import('../../../pages/shop/index.vue' /* webpackChunkName: "pages/shop/index" */))
const _e6d9d818 = () => interopDefault(import('../../../pages/terms-conditions.vue' /* webpackChunkName: "pages/terms-conditions" */))
const _2461016f = () => interopDefault(import('../../../pages/trainer.vue' /* webpackChunkName: "pages/trainer" */))
const _2ea0fe53 = () => interopDefault(import('../../../pages/trampoline.vue' /* webpackChunkName: "pages/trampoline" */))
const _5afbbb54 = () => interopDefault(import('../../../pages/shop/bestseller.vue' /* webpackChunkName: "pages/shop/bestseller" */))
const _a3ee81a8 = () => interopDefault(import('../../../pages/shop/refurbished-100.vue' /* webpackChunkName: "pages/shop/refurbished-100" */))
const _a04c7266 = () => interopDefault(import('../../../pages/shop/refurbished-112.vue' /* webpackChunkName: "pages/shop/refurbished-112" */))
const _9c8e3422 = () => interopDefault(import('../../../pages/shop/refurbished-125.vue' /* webpackChunkName: "pages/shop/refurbished-125" */))
const _5d72a24c = () => interopDefault(import('../../../pages/landing/_slug.vue' /* webpackChunkName: "pages/landing/_slug" */))
const _1388afe1 = () => interopDefault(import('../../../pages/product/_handle.vue' /* webpackChunkName: "pages/product/_handle" */))
const _762b9c93 = () => interopDefault(import('../../../pages/magazine/_category/_slug.vue' /* webpackChunkName: "pages/magazine/_category/_slug" */))
const _4787abbb = () => interopDefault(import('../../../pages/benefits/_category/_slug.vue' /* webpackChunkName: "pages/benefits/_category/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth-password-reset/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___unknown"
  }, {
    path: "/auth-sign-in/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___unknown"
  }, {
    path: "/auth-sign-up/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___unknown"
  }, {
    path: "/auth-verify/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___unknown"
  }, {
    path: "/benefits/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___unknown"
  }, {
    path: "/cart/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___unknown"
  }, {
    path: "/configurator-equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___unknown"
  }, {
    path: "/configurator/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___unknown"
  }, {
    path: "/consulting/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___unknown"
  }, {
    path: "/de-ch/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___de-ch"
  }, {
    path: "/de-eu/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___de-eu"
  }, {
    path: "/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___unknown"
  }, {
    path: "/en-ch/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___en-ch"
  }, {
    path: "/en-eu/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___en-eu"
  }, {
    path: "/en-us/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___en-us"
  }, {
    path: "/facts/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___unknown"
  }, {
    path: "/fr-ch/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___fr-ch"
  }, {
    path: "/fr-chundefined/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___fr-ch"
  }, {
    path: "/fr-eu/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___fr-eu"
  }, {
    path: "/fr-euundefined/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___fr-eu"
  }, {
    path: "/history/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___unknown"
  }, {
    path: "/imprint/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___unknown"
  }, {
    path: "/magazine/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___unknown"
  }, {
    path: "/nl-eu/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___nl-eu"
  }, {
    path: "/nl-euundefined/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___nl-eu"
  }, {
    path: "/order-confirmation/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___unknown"
  }, {
    path: "/platform/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___unknown"
  }, {
    path: "/privacy-policy/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___unknown"
  }, {
    path: "/returns/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___unknown"
  }, {
    path: "/right-of-withdrawal/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___unknown"
  }, {
    path: "/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___unknown"
  }, {
    path: "/shipping/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___unknown"
  }, {
    path: "/shop/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___unknown"
  }, {
    path: "/terms-conditions/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___unknown"
  }, {
    path: "/trainer/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___unknown"
  }, {
    path: "/trampoline/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___unknown"
  }, {
    path: "/video-imprint/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___unknown"
  }, {
    path: "/video-privacy-policy/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___unknown"
  }, {
    path: "/video-terms-conditions/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___unknown"
  }, {
    path: "/video/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___unknown"
  }, {
    path: "/de-ch/allgemeine-geschaeftsbedingungen/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___de-ch"
  }, {
    path: "/de-ch/anmelden/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___de-ch"
  }, {
    path: "/de-ch/beratung/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___de-ch"
  }, {
    path: "/de-ch/danke/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___de-ch"
  }, {
    path: "/de-ch/datenschutzerklaerung/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___de-ch"
  }, {
    path: "/de-ch/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___de-ch"
  }, {
    path: "/de-ch/email-verify/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___de-ch"
  }, {
    path: "/de-ch/impressum/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___de-ch"
  }, {
    path: "/de-ch/konfigurator/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___de-ch"
  }, {
    path: "/de-ch/konto/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___de-ch"
  }, {
    path: "/de-ch/magazin/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___de-ch"
  }, {
    path: "/de-ch/passwort-reset/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___de-ch"
  }, {
    path: "/de-ch/plattform/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___de-ch"
  }, {
    path: "/de-ch/registrieren/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___de-ch"
  }, {
    path: "/de-ch/retouren/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___de-ch"
  }, {
    path: "/de-ch/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___de-ch"
  }, {
    path: "/de-ch/shop/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___de-ch"
  }, {
    path: "/de-ch/trainer/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___de-ch"
  }, {
    path: "/de-ch/trampolin/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___de-ch"
  }, {
    path: "/de-ch/unsere-historie/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___de-ch"
  }, {
    path: "/de-ch/versand-und-lieferung/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___de-ch"
  }, {
    path: "/de-ch/video/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___de-ch"
  }, {
    path: "/de-ch/warenkorb/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___de-ch"
  }, {
    path: "/de-ch/widerrufsbelehrung/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___de-ch"
  }, {
    path: "/de-ch/wirkung/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___de-ch"
  }, {
    path: "/de-ch/zahlen-und-fakten/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___de-ch"
  }, {
    path: "/de-eu/allgemeine-geschaeftsbedingungen/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___de-eu"
  }, {
    path: "/de-eu/anmelden/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___de-eu"
  }, {
    path: "/de-eu/beratung/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___de-eu"
  }, {
    path: "/de-eu/danke/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___de-eu"
  }, {
    path: "/de-eu/datenschutzerklaerung/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___de-eu"
  }, {
    path: "/de-eu/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___de-eu"
  }, {
    path: "/de-eu/email-verify/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___de-eu"
  }, {
    path: "/de-eu/impressum/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___de-eu"
  }, {
    path: "/de-eu/konfigurator/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___de-eu"
  }, {
    path: "/de-eu/konto/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___de-eu"
  }, {
    path: "/de-eu/magazin/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___de-eu"
  }, {
    path: "/de-eu/passwort-reset/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___de-eu"
  }, {
    path: "/de-eu/plattform/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___de-eu"
  }, {
    path: "/de-eu/registrieren/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___de-eu"
  }, {
    path: "/de-eu/retouren/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___de-eu"
  }, {
    path: "/de-eu/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___de-eu"
  }, {
    path: "/de-eu/shop/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___de-eu"
  }, {
    path: "/de-eu/trainer/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___de-eu"
  }, {
    path: "/de-eu/trampolin/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___de-eu"
  }, {
    path: "/de-eu/unsere-historie/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___de-eu"
  }, {
    path: "/de-eu/versand-und-lieferung/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___de-eu"
  }, {
    path: "/de-eu/video/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___de-eu"
  }, {
    path: "/de-eu/warenkorb/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___de-eu"
  }, {
    path: "/de-eu/widerrufsbelehrung/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___de-eu"
  }, {
    path: "/de-eu/wirkung/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___de-eu"
  }, {
    path: "/de-eu/zahlen-und-fakten/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___de-eu"
  }, {
    path: "/en-ch/account/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___en-ch"
  }, {
    path: "/en-ch/benefits/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___en-ch"
  }, {
    path: "/en-ch/configurator/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___en-ch"
  }, {
    path: "/en-ch/consulting/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___en-ch"
  }, {
    path: "/en-ch/data-protection/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___en-ch"
  }, {
    path: "/en-ch/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en-ch"
  }, {
    path: "/en-ch/email-verify/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___en-ch"
  }, {
    path: "/en-ch/facts-and-figures/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___en-ch"
  }, {
    path: "/en-ch/general-terms-and-conditions/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___en-ch"
  }, {
    path: "/en-ch/imprint/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___en-ch"
  }, {
    path: "/en-ch/magazine/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en-ch"
  }, {
    path: "/en-ch/our-history/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___en-ch"
  }, {
    path: "/en-ch/password-reset/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___en-ch"
  }, {
    path: "/en-ch/returns/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___en-ch"
  }, {
    path: "/en-ch/revocation-policy/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___en-ch"
  }, {
    path: "/en-ch/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___en-ch"
  }, {
    path: "/en-ch/shipping-and-delivery/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___en-ch"
  }, {
    path: "/en-ch/shopping-cart/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___en-ch"
  }, {
    path: "/en-ch/sign-in/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___en-ch"
  }, {
    path: "/en-ch/sign-up/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___en-ch"
  }, {
    path: "/en-ch/store/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___en-ch"
  }, {
    path: "/en-ch/thank-you/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___en-ch"
  }, {
    path: "/en-ch/trainer/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___en-ch"
  }, {
    path: "/en-ch/training-platform/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___en-ch"
  }, {
    path: "/en-ch/trampoline/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___en-ch"
  }, {
    path: "/en-ch/video/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___en-ch"
  }, {
    path: "/en-eu/account/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___en-eu"
  }, {
    path: "/en-eu/benefits/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___en-eu"
  }, {
    path: "/en-eu/configurator/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___en-eu"
  }, {
    path: "/en-eu/consulting/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___en-eu"
  }, {
    path: "/en-eu/data-protection/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___en-eu"
  }, {
    path: "/en-eu/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en-eu"
  }, {
    path: "/en-eu/email-verify/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___en-eu"
  }, {
    path: "/en-eu/facts-and-figures/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___en-eu"
  }, {
    path: "/en-eu/general-terms-and-conditions/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___en-eu"
  }, {
    path: "/en-eu/imprint/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___en-eu"
  }, {
    path: "/en-eu/magazine/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en-eu"
  }, {
    path: "/en-eu/our-history/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___en-eu"
  }, {
    path: "/en-eu/password-reset/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___en-eu"
  }, {
    path: "/en-eu/returns/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___en-eu"
  }, {
    path: "/en-eu/revocation-policy/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___en-eu"
  }, {
    path: "/en-eu/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___en-eu"
  }, {
    path: "/en-eu/shipping-and-delivery/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___en-eu"
  }, {
    path: "/en-eu/shopping-cart/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___en-eu"
  }, {
    path: "/en-eu/sign-in/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___en-eu"
  }, {
    path: "/en-eu/sign-up/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___en-eu"
  }, {
    path: "/en-eu/store/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___en-eu"
  }, {
    path: "/en-eu/thank-you/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___en-eu"
  }, {
    path: "/en-eu/trainer/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___en-eu"
  }, {
    path: "/en-eu/training-platform/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___en-eu"
  }, {
    path: "/en-eu/trampoline/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___en-eu"
  }, {
    path: "/en-eu/video/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___en-eu"
  }, {
    path: "/en-us/account/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___en-us"
  }, {
    path: "/en-us/benefits/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___en-us"
  }, {
    path: "/en-us/configurator/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___en-us"
  }, {
    path: "/en-us/consulting/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___en-us"
  }, {
    path: "/en-us/data-protection/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___en-us"
  }, {
    path: "/en-us/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en-us"
  }, {
    path: "/en-us/email-verify/",
    component: _79793f78,
    pathToRegexpOptions: {"strict":true},
    name: "auth-verify___en-us"
  }, {
    path: "/en-us/facts-and-figures/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___en-us"
  }, {
    path: "/en-us/general-terms-and-conditions/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___en-us"
  }, {
    path: "/en-us/imprint/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___en-us"
  }, {
    path: "/en-us/magazine/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___en-us"
  }, {
    path: "/en-us/our-history/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___en-us"
  }, {
    path: "/en-us/password-reset/",
    component: _548ef99c,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset___en-us"
  }, {
    path: "/en-us/returns/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___en-us"
  }, {
    path: "/en-us/revocation-policy/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___en-us"
  }, {
    path: "/en-us/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___en-us"
  }, {
    path: "/en-us/shipping-and-delivery/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___en-us"
  }, {
    path: "/en-us/shopping-cart/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___en-us"
  }, {
    path: "/en-us/sign-in/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___en-us"
  }, {
    path: "/en-us/sign-up/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___en-us"
  }, {
    path: "/en-us/store/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___en-us"
  }, {
    path: "/en-us/thank-you/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___en-us"
  }, {
    path: "/en-us/trainer/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___en-us"
  }, {
    path: "/en-us/training-platform/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___en-us"
  }, {
    path: "/en-us/trampoline/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___en-us"
  }, {
    path: "/en-us/video/",
    component: _e69e5d10,
    pathToRegexpOptions: {"strict":true},
    name: "video___en-us"
  }, {
    path: "/fr-ch/bienfaits/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___fr-ch"
  }, {
    path: "/fr-ch/chiffres-cles/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___fr-ch"
  }, {
    path: "/fr-ch/conditions-de-retractation/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___fr-ch"
  }, {
    path: "/fr-ch/conditions-generales/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___fr-ch"
  }, {
    path: "/fr-ch/configurateur/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___fr-ch"
  }, {
    path: "/fr-ch/conseil/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___fr-ch"
  }, {
    path: "/fr-ch/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___fr-ch"
  }, {
    path: "/fr-ch/entraineurs/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___fr-ch"
  }, {
    path: "/fr-ch/expedition-et-livraison/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___fr-ch"
  }, {
    path: "/fr-ch/magazine/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___fr-ch"
  }, {
    path: "/fr-ch/mentions-legales/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___fr-ch"
  }, {
    path: "/fr-ch/merci/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___fr-ch"
  }, {
    path: "/fr-ch/notre-histoire/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___fr-ch"
  }, {
    path: "/fr-ch/panier/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___fr-ch"
  }, {
    path: "/fr-ch/plateforme-de-formation/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___fr-ch"
  }, {
    path: "/fr-ch/protection-des-donnees/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___fr-ch"
  }, {
    path: "/fr-ch/retours/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___fr-ch"
  }, {
    path: "/fr-ch/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___fr-ch"
  }, {
    path: "/fr-ch/shop/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___fr-ch"
  }, {
    path: "/fr-ch/sign-in/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___fr-ch"
  }, {
    path: "/fr-ch/sign-up/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___fr-ch"
  }, {
    path: "/fr-ch/trampoline/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___fr-ch"
  }, {
    path: "/fr-eu/bienfaits/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___fr-eu"
  }, {
    path: "/fr-eu/chiffres-cles/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___fr-eu"
  }, {
    path: "/fr-eu/conditions-de-retractation/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___fr-eu"
  }, {
    path: "/fr-eu/conditions-generales/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___fr-eu"
  }, {
    path: "/fr-eu/configurateur/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___fr-eu"
  }, {
    path: "/fr-eu/conseil/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___fr-eu"
  }, {
    path: "/fr-eu/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___fr-eu"
  }, {
    path: "/fr-eu/entraineurs/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___fr-eu"
  }, {
    path: "/fr-eu/expedition-et-livraison/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___fr-eu"
  }, {
    path: "/fr-eu/magazine/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___fr-eu"
  }, {
    path: "/fr-eu/mentions-legales/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___fr-eu"
  }, {
    path: "/fr-eu/merci/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___fr-eu"
  }, {
    path: "/fr-eu/notre-histoire/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___fr-eu"
  }, {
    path: "/fr-eu/panier/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___fr-eu"
  }, {
    path: "/fr-eu/plateforme-de-formation/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___fr-eu"
  }, {
    path: "/fr-eu/protection-des-donnees/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___fr-eu"
  }, {
    path: "/fr-eu/retours/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___fr-eu"
  }, {
    path: "/fr-eu/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___fr-eu"
  }, {
    path: "/fr-eu/shop/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___fr-eu"
  }, {
    path: "/fr-eu/sign-in/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___fr-eu"
  }, {
    path: "/fr-eu/sign-up/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___fr-eu"
  }, {
    path: "/fr-eu/trampoline/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___fr-eu"
  }, {
    path: "/nl-eu/advisering/",
    component: _e6f2c7a8,
    pathToRegexpOptions: {"strict":true},
    name: "consulting___nl-eu"
  }, {
    path: "/nl-eu/algemene-voorwaarden/",
    component: _e6d9d818,
    pathToRegexpOptions: {"strict":true},
    name: "terms-conditions___nl-eu"
  }, {
    path: "/nl-eu/annuleringsregeling/",
    component: _817bf098,
    pathToRegexpOptions: {"strict":true},
    name: "right-of-withdrawal___nl-eu"
  }, {
    path: "/nl-eu/bedankt/",
    component: _0fce730a,
    pathToRegexpOptions: {"strict":true},
    name: "order-confirmation___nl-eu"
  }, {
    path: "/nl-eu/configurator/",
    component: _26636beb,
    pathToRegexpOptions: {"strict":true},
    name: "configurator___nl-eu"
  }, {
    path: "/nl-eu/disclaimer/",
    component: _0824f2d1,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___nl-eu"
  }, {
    path: "/nl-eu/feiten-en-cijfers/",
    component: _7b09387e,
    pathToRegexpOptions: {"strict":true},
    name: "facts___nl-eu"
  }, {
    path: "/nl-eu/functie/",
    component: _d2454816,
    pathToRegexpOptions: {"strict":true},
    name: "benefits___nl-eu"
  }, {
    path: "/nl-eu/impressum/",
    component: _5703d6c3,
    pathToRegexpOptions: {"strict":true},
    name: "imprint___nl-eu"
  }, {
    path: "/nl-eu/magazine/",
    component: _f2900a66,
    pathToRegexpOptions: {"strict":true},
    name: "magazine___nl-eu"
  }, {
    path: "/nl-eu/onze-geschiedenis/",
    component: _7bef7c64,
    pathToRegexpOptions: {"strict":true},
    name: "history___nl-eu"
  }, {
    path: "/nl-eu/opleidingsplatform/",
    component: _004dadae,
    pathToRegexpOptions: {"strict":true},
    name: "platform___nl-eu"
  }, {
    path: "/nl-eu/privacybescherming/",
    component: _245a834d,
    pathToRegexpOptions: {"strict":true},
    name: "privacy-policy___nl-eu"
  }, {
    path: "/nl-eu/retourzendingen/",
    component: _5581d6fd,
    pathToRegexpOptions: {"strict":true},
    name: "returns___nl-eu"
  }, {
    path: "/nl-eu/safety-instructions/",
    component: _31c354fa,
    pathToRegexpOptions: {"strict":true},
    name: "safety-instructions___nl-eu"
  }, {
    path: "/nl-eu/sign-in/",
    component: _dd203174,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-in___nl-eu"
  }, {
    path: "/nl-eu/sign-up/",
    component: _b3f38488,
    pathToRegexpOptions: {"strict":true},
    name: "auth-sign-up___nl-eu"
  }, {
    path: "/nl-eu/trainer/",
    component: _2461016f,
    pathToRegexpOptions: {"strict":true},
    name: "trainer___nl-eu"
  }, {
    path: "/nl-eu/trampoline/",
    component: _2ea0fe53,
    pathToRegexpOptions: {"strict":true},
    name: "trampoline___nl-eu"
  }, {
    path: "/nl-eu/verzending-en-bezorging/",
    component: _4258ee38,
    pathToRegexpOptions: {"strict":true},
    name: "shipping___nl-eu"
  }, {
    path: "/nl-eu/winkel/",
    component: _5ebd16af,
    pathToRegexpOptions: {"strict":true},
    name: "shop___nl-eu"
  }, {
    path: "/nl-eu/winkelwagen/",
    component: _42f39c56,
    pathToRegexpOptions: {"strict":true},
    name: "cart___nl-eu"
  }, {
    path: "/shop/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___unknown"
  }, {
    path: "/shop/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___unknown"
  }, {
    path: "/shop/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___unknown"
  }, {
    path: "/shop/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___unknown"
  }, {
    path: "/video/account/",
    component: _464381d3,
    pathToRegexpOptions: {"strict":true},
    name: "video-account___unknown"
  }, {
    path: "/video/activities/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___unknown"
  }, {
    path: "/video/detail/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___unknown"
  }, {
    path: "/video/find/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___unknown"
  }, {
    path: "/video/stars/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___unknown"
  }, {
    path: "/de-ch/konfigurator/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___de-ch"
  }, {
    path: "/de-ch/shop/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___de-ch"
  }, {
    path: "/de-ch/shop/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___de-ch"
  }, {
    path: "/de-ch/shop/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___de-ch"
  }, {
    path: "/de-ch/shop/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___de-ch"
  }, {
    path: "/de-ch/video/agb/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___de-ch"
  }, {
    path: "/de-ch/video/aktivitaeten/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___de-ch"
  }, {
    path: "/de-ch/video/datenschutzerklaerung/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___de-ch"
  }, {
    path: "/de-ch/video/detail/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___de-ch"
  }, {
    path: "/de-ch/video/favoriten/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___de-ch"
  }, {
    path: "/de-ch/video/finden/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___de-ch"
  }, {
    path: "/de-ch/video/impressum/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___de-ch"
  }, {
    path: "/de-ch/video/kollektion/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___de-ch"
  }, {
    path: "/de-ch/video/plan/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___de-ch"
  }, {
    path: "/de-eu/konfigurator/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___de-eu"
  }, {
    path: "/de-eu/shop/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___de-eu"
  }, {
    path: "/de-eu/shop/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___de-eu"
  }, {
    path: "/de-eu/shop/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___de-eu"
  }, {
    path: "/de-eu/shop/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___de-eu"
  }, {
    path: "/de-eu/video/agb/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___de-eu"
  }, {
    path: "/de-eu/video/aktivitaeten/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___de-eu"
  }, {
    path: "/de-eu/video/datenschutzerklaerung/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___de-eu"
  }, {
    path: "/de-eu/video/detail/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___de-eu"
  }, {
    path: "/de-eu/video/favoriten/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___de-eu"
  }, {
    path: "/de-eu/video/finden/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___de-eu"
  }, {
    path: "/de-eu/video/impressum/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___de-eu"
  }, {
    path: "/de-eu/video/kollektion/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___de-eu"
  }, {
    path: "/de-eu/video/plan/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___de-eu"
  }, {
    path: "/en-ch/configurator/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___en-ch"
  }, {
    path: "/en-ch/store/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___en-ch"
  }, {
    path: "/en-ch/store/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___en-ch"
  }, {
    path: "/en-ch/store/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___en-ch"
  }, {
    path: "/en-ch/store/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___en-ch"
  }, {
    path: "/en-ch/video/activities/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___en-ch"
  }, {
    path: "/en-ch/video/collection/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___en-ch"
  }, {
    path: "/en-ch/video/data-protection/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___en-ch"
  }, {
    path: "/en-ch/video/detail/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___en-ch"
  }, {
    path: "/en-ch/video/favorites/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___en-ch"
  }, {
    path: "/en-ch/video/find/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___en-ch"
  }, {
    path: "/en-ch/video/general-terms-and-conditions/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___en-ch"
  }, {
    path: "/en-ch/video/imprint/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___en-ch"
  }, {
    path: "/en-ch/video/plan/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___en-ch"
  }, {
    path: "/en-eu/configurator/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___en-eu"
  }, {
    path: "/en-eu/store/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___en-eu"
  }, {
    path: "/en-eu/store/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___en-eu"
  }, {
    path: "/en-eu/store/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___en-eu"
  }, {
    path: "/en-eu/store/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___en-eu"
  }, {
    path: "/en-eu/video/activities/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___en-eu"
  }, {
    path: "/en-eu/video/collection/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___en-eu"
  }, {
    path: "/en-eu/video/data-protection/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___en-eu"
  }, {
    path: "/en-eu/video/detail/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___en-eu"
  }, {
    path: "/en-eu/video/favorites/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___en-eu"
  }, {
    path: "/en-eu/video/find/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___en-eu"
  }, {
    path: "/en-eu/video/general-terms-and-conditions/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___en-eu"
  }, {
    path: "/en-eu/video/imprint/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___en-eu"
  }, {
    path: "/en-eu/video/plan/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___en-eu"
  }, {
    path: "/en-us/configurator/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___en-us"
  }, {
    path: "/en-us/store/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___en-us"
  }, {
    path: "/en-us/store/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___en-us"
  }, {
    path: "/en-us/store/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___en-us"
  }, {
    path: "/en-us/store/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___en-us"
  }, {
    path: "/en-us/video/activities/",
    component: _4d8fdafa,
    pathToRegexpOptions: {"strict":true},
    name: "video-activities___en-us"
  }, {
    path: "/en-us/video/collection/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___en-us"
  }, {
    path: "/en-us/video/data-protection/",
    component: _3a8d6142,
    pathToRegexpOptions: {"strict":true},
    name: "video-privacy-policy___en-us"
  }, {
    path: "/en-us/video/detail/",
    component: _bc8725ca,
    pathToRegexpOptions: {"strict":true},
    name: "video-detail___en-us"
  }, {
    path: "/en-us/video/favorites/",
    component: _3dda0d87,
    pathToRegexpOptions: {"strict":true},
    name: "video-stars___en-us"
  }, {
    path: "/en-us/video/find/",
    component: _f7f55974,
    pathToRegexpOptions: {"strict":true},
    name: "video-find___en-us"
  }, {
    path: "/en-us/video/general-terms-and-conditions/",
    component: _2e6f2386,
    pathToRegexpOptions: {"strict":true},
    name: "video-terms-conditions___en-us"
  }, {
    path: "/en-us/video/imprint/",
    component: _a592ca1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-imprint___en-us"
  }, {
    path: "/en-us/video/plan/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___en-us"
  }, {
    path: "/fr-ch/configurateur/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___fr-ch"
  }, {
    path: "/fr-ch/shop/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___fr-ch"
  }, {
    path: "/fr-ch/store/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___fr-ch"
  }, {
    path: "/fr-ch/store/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___fr-ch"
  }, {
    path: "/fr-ch/store/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___fr-ch"
  }, {
    path: "/fr-eu/configurateur/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___fr-eu"
  }, {
    path: "/fr-eu/shop/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___fr-eu"
  }, {
    path: "/fr-eu/store/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___fr-eu"
  }, {
    path: "/fr-eu/store/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___fr-eu"
  }, {
    path: "/fr-eu/store/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___fr-eu"
  }, {
    path: "/nl-eu/configurator/equipment/",
    component: _6e30ffac,
    pathToRegexpOptions: {"strict":true},
    name: "configurator-equipment___nl-eu"
  }, {
    path: "/nl-eu/store/refurbished-100/",
    component: _a3ee81a8,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-100___nl-eu"
  }, {
    path: "/nl-eu/store/refurbished-112/",
    component: _a04c7266,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-112___nl-eu"
  }, {
    path: "/nl-eu/store/refurbished-125/",
    component: _9c8e3422,
    pathToRegexpOptions: {"strict":true},
    name: "shop-refurbished-125___nl-eu"
  }, {
    path: "/nl-eu/winkel/bestseller/",
    component: _5afbbb54,
    pathToRegexpOptions: {"strict":true},
    name: "shop-bestseller___nl-eu"
  }, {
    path: "/video/find/selection/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___unknown"
  }, {
    path: "/de-ch/video/finden/filter/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___de-ch"
  }, {
    path: "/de-ch/video/finden/selektion/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___de-ch"
  }, {
    path: "/de-eu/video/finden/filter/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___de-eu"
  }, {
    path: "/de-eu/video/finden/selektion/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___de-eu"
  }, {
    path: "/en-ch/video/find/filter/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___en-ch"
  }, {
    path: "/en-ch/video/find/selection/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___en-ch"
  }, {
    path: "/en-eu/video/find/filter/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___en-eu"
  }, {
    path: "/en-eu/video/find/selection/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___en-eu"
  }, {
    path: "/en-us/video/find/filter/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___en-us"
  }, {
    path: "/en-us/video/find/selection/",
    component: _72c03e00,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-selection___en-us"
  }, {
    path: "/video/find/collections/goals/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___unknown"
  }, {
    path: "/video/find/collections/levels/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___unknown"
  }, {
    path: "/video/find/plans/goals/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___unknown"
  }, {
    path: "/video/find/plans/levels/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___unknown"
  }, {
    path: "/video/find/videos/body-focus-areas/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___unknown"
  }, {
    path: "/video/find/videos/durations/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___unknown"
  }, {
    path: "/video/find/videos/intensities/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___unknown"
  }, {
    path: "/video/find/videos/single-filter/",
    component: _42744162,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-single-filter___unknown"
  }, {
    path: "/video/find/videos/sports/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___unknown"
  }, {
    path: "/video/find/videos/trainers/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___unknown"
  }, {
    path: "/video/playlist/collection/detail/",
    component: _568d60a2,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-collection-detail___unknown"
  }, {
    path: "/video/playlist/plan/detail/",
    component: _81cfebf8,
    pathToRegexpOptions: {"strict":true},
    name: "video-playlist-plan-detail___unknown"
  }, {
    path: "/de-ch/video/finden/kollektionen/level/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___de-ch"
  }, {
    path: "/de-ch/video/finden/kollektionen/ziel/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___de-ch"
  }, {
    path: "/de-ch/video/finden/plaene/level/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___de-ch"
  }, {
    path: "/de-ch/video/finden/plaene/ziel/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___de-ch"
  }, {
    path: "/de-ch/video/finden/videos/dauer/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___de-ch"
  }, {
    path: "/de-ch/video/finden/videos/intensitaet/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___de-ch"
  }, {
    path: "/de-ch/video/finden/videos/koerperschwerpunkt/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___de-ch"
  }, {
    path: "/de-ch/video/finden/videos/trainer/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___de-ch"
  }, {
    path: "/de-ch/video/finden/videos/trainingsart/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___de-ch"
  }, {
    path: "/de-eu/video/finden/kollektionen/level/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___de-eu"
  }, {
    path: "/de-eu/video/finden/kollektionen/ziel/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___de-eu"
  }, {
    path: "/de-eu/video/finden/plaene/level/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___de-eu"
  }, {
    path: "/de-eu/video/finden/plaene/ziel/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___de-eu"
  }, {
    path: "/de-eu/video/finden/videos/dauer/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___de-eu"
  }, {
    path: "/de-eu/video/finden/videos/intensitaet/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___de-eu"
  }, {
    path: "/de-eu/video/finden/videos/koerperschwerpunkt/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___de-eu"
  }, {
    path: "/de-eu/video/finden/videos/trainer/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___de-eu"
  }, {
    path: "/de-eu/video/finden/videos/trainingsart/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___de-eu"
  }, {
    path: "/en-ch/video/find/collections/goal/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___en-ch"
  }, {
    path: "/en-ch/video/find/collections/level/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___en-ch"
  }, {
    path: "/en-ch/video/find/plans/goal/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___en-ch"
  }, {
    path: "/en-ch/video/find/plans/level/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___en-ch"
  }, {
    path: "/en-ch/video/find/videos/body-focus-area/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___en-ch"
  }, {
    path: "/en-ch/video/find/videos/duration/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___en-ch"
  }, {
    path: "/en-ch/video/find/videos/intensity/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___en-ch"
  }, {
    path: "/en-ch/video/find/videos/sport/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___en-ch"
  }, {
    path: "/en-ch/video/find/videos/trainer/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___en-ch"
  }, {
    path: "/en-eu/video/find/collections/goal/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___en-eu"
  }, {
    path: "/en-eu/video/find/collections/level/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___en-eu"
  }, {
    path: "/en-eu/video/find/plans/goal/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___en-eu"
  }, {
    path: "/en-eu/video/find/plans/level/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___en-eu"
  }, {
    path: "/en-eu/video/find/videos/body-focus-area/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___en-eu"
  }, {
    path: "/en-eu/video/find/videos/duration/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___en-eu"
  }, {
    path: "/en-eu/video/find/videos/intensity/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___en-eu"
  }, {
    path: "/en-eu/video/find/videos/sport/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___en-eu"
  }, {
    path: "/en-eu/video/find/videos/trainer/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___en-eu"
  }, {
    path: "/en-us/video/find/collections/goal/",
    component: _0515b13a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-goals___en-us"
  }, {
    path: "/en-us/video/find/collections/level/",
    component: _b96bcc36,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-collections-levels___en-us"
  }, {
    path: "/en-us/video/find/plans/goal/",
    component: _69e11662,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-goals___en-us"
  }, {
    path: "/en-us/video/find/plans/level/",
    component: _c6ee6e20,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-plans-levels___en-us"
  }, {
    path: "/en-us/video/find/videos/body-focus-area/",
    component: _bb215f1e,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-body-focus-areas___en-us"
  }, {
    path: "/en-us/video/find/videos/duration/",
    component: _4cd403a4,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-durations___en-us"
  }, {
    path: "/en-us/video/find/videos/intensity/",
    component: _47a78616,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-intensities___en-us"
  }, {
    path: "/en-us/video/find/videos/sport/",
    component: _5b3c868a,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-sports___en-us"
  }, {
    path: "/en-us/video/find/videos/trainer/",
    component: _3d250129,
    pathToRegexpOptions: {"strict":true},
    name: "video-find-videos-trainers___en-us"
  }, {
    path: "/de-ch/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___de-ch"
  }, {
    path: "/de-ch/produkt/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___de-ch"
  }, {
    path: "/de-eu/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___de-eu"
  }, {
    path: "/de-eu/produkt/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___de-eu"
  }, {
    path: "/en-ch/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___en-ch"
  }, {
    path: "/en-ch/product/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___en-ch"
  }, {
    path: "/en-eu/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___en-eu"
  }, {
    path: "/en-eu/product/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___en-eu"
  }, {
    path: "/en-us/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___en-us"
  }, {
    path: "/en-us/product/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___en-us"
  }, {
    path: "/fr-ch/article/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___fr-ch"
  }, {
    path: "/fr-ch/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___fr-ch"
  }, {
    path: "/fr-eu/article/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___fr-eu"
  }, {
    path: "/fr-eu/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___fr-eu"
  }, {
    path: "/nl-eu/artikel/:handle/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___nl-eu"
  }, {
    path: "/nl-eu/lp/:slug/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___nl-eu"
  }, {
    path: "/de-ch/magazin/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___de-ch"
  }, {
    path: "/de-ch/wirkung/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___de-ch"
  }, {
    path: "/de-eu/magazin/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___de-eu"
  }, {
    path: "/de-eu/wirkung/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___de-eu"
  }, {
    path: "/en-ch/benefits/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___en-ch"
  }, {
    path: "/en-ch/magazine/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___en-ch"
  }, {
    path: "/en-eu/benefits/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___en-eu"
  }, {
    path: "/en-eu/magazine/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___en-eu"
  }, {
    path: "/en-us/benefits/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___en-us"
  }, {
    path: "/en-us/magazine/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___en-us"
  }, {
    path: "/fr-ch/effet/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___fr-ch"
  }, {
    path: "/fr-ch/magazine/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___fr-ch"
  }, {
    path: "/fr-eu/effet/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___fr-eu"
  }, {
    path: "/fr-eu/magazine/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___fr-eu"
  }, {
    path: "/nl-eu/effect/:category/:slug/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___nl-eu"
  }, {
    path: "/nl-eu/magazine/:category/:slug/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___nl-eu"
  }, {
    path: "/landing/:slug?/",
    component: _5d72a24c,
    pathToRegexpOptions: {"strict":true},
    name: "landing-slug___unknown"
  }, {
    path: "/product/:handle?/",
    component: _1388afe1,
    pathToRegexpOptions: {"strict":true},
    name: "product-handle___unknown"
  }, {
    path: "/benefits/:category/:slug?/",
    component: _4787abbb,
    pathToRegexpOptions: {"strict":true},
    name: "benefits-category-slug___unknown"
  }, {
    path: "/magazine/:category/:slug?/",
    component: _762b9c93,
    pathToRegexpOptions: {"strict":true},
    name: "magazine-category-slug___unknown"
  }, {
    path: "/",
    component: _3d6810e8,
    pathToRegexpOptions: {"strict":true},
    name: "index___unknown"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
